@if (activeSection === 'add') {
  <mg-add-shop
    [addNewShop]="addNewShop"
    [cancelBtnLabel]="cancelBtnLabel"
    (canceld)="canceld.emit()"
    (completed)="activeSection = 'focus'"
  ></mg-add-shop>
}
@if (activeSection === 'focus') {
  <mg-add-shop-focus
    [addNewShop]="addNewShop"
    (completed)="activeSection = 'service-price'"
  ></mg-add-shop-focus>
}
@if (activeSection === 'service-price') {
  <mg-add-shop-service-price
    [addNewShop]="addNewShop"
    (completed)="completed.emit()"
  ></mg-add-shop-service-price>
}
